module.exports = "<router-outlet>\r\n  <app-spinner><app-title></app-title></app-spinner>\r\n</router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/auth/auth.component.html
// module id = ./src/app/layout/auth/auth.component.html
// module chunks = main